export default __webpack_public_path__ + "static/media/1119.1ce7e4d4.png";